export default __webpack_public_path__ + "assets/img/sidebar-ex1.png";